'use client';
import Script from 'next/script';

import type { ReactNode } from 'react';

import classNames from 'classnames';

import CheckRequireUserData from '@shared/common/components/CheckRequireUserData/CheckRequireUserData';
import { Footer } from '@shared/common/components/Footer';
import { NavLayout } from '@shared/common/components/NavLayout';
import { swapPrimaryNav } from '@shared/common/components/NavLayout/navSetting';
import type { NavLayoutLinkBase } from '@shared/common/components/NavLayout/types';
import { useAuth } from '@shared/common/providers/AuthProvider';
import {
  useAuthModal,
  useBanxaModal,
  useSupportModal,
} from '@shared/common/providers/GlobalModalsProvider';
import { nextProjectUrl } from '@shared/constants/urls';

import { Swap } from '@ui/uikit/components/logos/Swap';

interface MainLayoutProps {
  children?: ReactNode;
}

const quickNavItems: NavLayoutLinkBase[] = [
  {
    id: 'swap',
    label: 'Swap',
    href: '/',
  },
  {
    id: 'how-it-works',
    label: 'How it works ',
    href: 'https://docs.magicsquare.io/for-users/magic-swap',
  },
];

const MainLayout = ({ children }: MainLayoutProps) => {
  const { user, logout } = useAuth();
  const modal = useBanxaModal();
  const { userEvmWallet } = useAuth();
  const authModal = useAuthModal();
  const supportModal = useSupportModal();

  const handleConnectClick = () => {
    authModal.open();
  };

  const handleBanxaBuyToken = () => {
    modal.open({
      walletAddress: userEvmWallet?.attributes.address,
    });
  };

  return (
    <>
      <NavLayout
        primaryNavMenuTitle="Magic Swap"
        logo={Swap}
        user={user ? { data: user } : undefined}
        onLogin={handleConnectClick}
        onLogout={logout}
        onSupport={supportModal.open}
        onBanxaBuyToken={handleBanxaBuyToken}
        primaryNavItems={swapPrimaryNav}
        quickNavItems={quickNavItems}
      >
        <div className={classNames('w-full flex-auto flex flex-col')}>
          {children}

          <Footer
            landingPageLinkUrl={nextProjectUrl.magicsquare('/')}
          />
        </div>
      </NavLayout>
      <CheckRequireUserData user={user} />
      <Script src="https://accounts.google.com/gsi/client" async defer strategy="lazyOnload" />
    </>
  );
};

export default MainLayout;
